import { buySubscription } from '@/clients/restaurant/subscriptons';
import Button from '@/components/ui/Button';
import { storage_keys } from '@/constant/configs';
import { cn } from '@/lib/utils';
import STRINGS from '@/lib/utils/translation';
import { useUserStore } from '@/stores/restuarant/user';
import Cookies from 'js-cookie';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import type { PricingPlan } from '@/lib/types/restaurant/PricingPlan';
import If from '@/components/ui/If';

type Props = {
  item: PricingPlan;
  closeModal: () => void;
  code?: string;
};

export default function BuyPlan({ item, closeModal, code }: Props) {
  const t = useTranslations();

  const [paymentMethod, setPaymentMethod] = useState('');

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const resProfile = useUserStore((state) => state);

  const paymentData = [
    {
      thumbUrl: '/paypal.png',
      width: 106,
      height: 52,
      gateway: 'paypal',
      name: 'PayPal',
      show: Boolean(item.paypal_plan_id),
    },
    {
      thumbUrl: '/stripe.png',
      width: 129,
      height: 30,
      gateway: 'stripe',
      name: t(`${STRINGS.COMMON}.credit_card`),
      show: Boolean(item.stripe_plan_id),
    },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const subToast = toast.loading(t(STRINGS.COMMON + '.processing'), {
      duration: 20000,
    });
    if (item.free_of_charge) {
      setPaymentMethod('stripe');
    }
    try {
      const payload: { [key: string]: any } = {
        product_plan_id: item.id,
        payment_method: paymentMethod,
      };
      if (code) {
        payload['product_link_code'] = code;
      }
      const subcription = await buySubscription(payload);

      // const restaurantData = await getRestaurantData();
      // const token = Cookies.get(storage_keys.restaurant_token) as string;
      const token = localStorage.getItem(
        storage_keys.restaurant_token
      ) as string;

      await resProfile.setUser(token);

      toast.success(subcription.data?.message ?? 'Success!', { id: subToast });
      setIsLoading(false);

      if (subcription.data.data?.payment_data.data?.approval_url) {
        window.location.href =
          subcription.data.data.payment_data.data.approval_url;
      }
    } catch (error: any) {
      setIsLoading(false);
      toast.error(
        error.response?.data?.message ?? t(STRINGS.COMMON + '.fail_process'),
        {
          id: subToast,
        }
      );
    } finally {
      closeModal();
    }
  };

  return (
    <div className="mt-5">
      <div className="">
        <h4 className="mb-5 font-medium">Plan: {item?.name}</h4>
      </div>

      <form onSubmit={handleSubmit} className="space-y-10">
        <If condition={!item.free_of_charge}>
          <div className="rounded-[10px] border border-neutral-100 bg-white">
            {paymentData
              ?.filter((item) => item.show)
              .map((item: any) => {
                return (
                  <label
                    className="flex min-h-[75px] cursor-pointer items-center justify-between border-b-neutral-100 p-4 xl:min-h-[89px] xl:p-5 [&:not(:last-child)]:border-b"
                    key={item?.gateway}
                    htmlFor={`payment-${item?.gateway}`}
                  >
                    <div className="variation-radio flex items-center">
                      <input
                        type="radio"
                        id={`payment-${item?.gateway}`}
                        value={item?.gateway}
                        onChange={() => setPaymentMethod(item?.gateway)}
                        checked={paymentMethod === item?.gateway}
                        className="mr-3 h-[25px] w-[25px] rounded-full border-2 border-neutral-100 text-white checked:!border-primary-700 focus:ring-0 focus:ring-offset-0"
                      />
                      <span className="text-lg capitalize text-title">
                        {item?.name}
                      </span>
                    </div>
                    <div className="max-w-[130px]">
                      <Image
                        src={item?.thumbUrl}
                        width={item?.width}
                        height={item?.height}
                        alt={item?.gateway}
                        sizes="100vw"
                        className={cn(
                          `h-auto max-w-full md:w-[${item?.width}] md:h-[${item?.height}]`
                        )}
                      />
                    </div>
                  </label>
                );
              })}
          </div>
        </If>
        <Button
          type="submit"
          disabled={isLoading}
          className="min-w-[200px] py-4"
        >
          <If
            condition={item.free_of_charge}
            fallback={t('Subscription.buy_now')}
          >
            {t('common.confirm')}
          </If>
        </Button>
      </form>
    </div>
  );
}
